// 增值服务订单（销售合同下的业务单据页面配置）
import {
  getContractAddedServiceListData,
  saveContractAddedServiceData,
  saveContractAddedServiceEditData,
  saveContractAddedServiceDeleteData
} from "../../api/api.js";

export default {
  key: "added",
  title: "增值服务订单",
  short: "增值服务",
  icon: "add-o",
  listFn: getContractAddedServiceListData,
  saveFn: saveContractAddedServiceData,
  editFn: saveContractAddedServiceEditData,
  deleteFn: saveContractAddedServiceDeleteData,
  // 卡片标题：服务名称 · 金额 · 日期（旧逻辑取到 quantity，两条都显示成「3」）
  titleFields: ["value_added_services_goods_name", "value_added_services_amount", "on_date"],
  fields: [
    { prop: "on_date", label: "时间", type: "date", group: "服务信息" },
    {
      prop: "value_added_services_name", label: "类型", type: "select", required: true, group: "服务信息",
      options: [
        { label: "茶歇", value: "茶歇" },
        { label: "设备租赁", value: "设备租赁" },
        { label: "打印装订", value: "打印装订" },
        { label: "会务服务", value: "会务服务" },
        { label: "其他", value: "其他" }
      ]
    },
    { prop: "value_added_services_goods_name", label: "名称", type: "text", group: "服务信息" },
    { prop: "quantity", label: "数量", type: "number", group: "服务信息" }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/contract/AddedServices.js